<script setup lang="ts">
import Typography from '../ui/typography/Typography.vue'

const {
  count,
  label,
  icon,
  size = 'large'
} = defineProps<{
  count: number
  label: string
  icon: Object
  size?: 'small' | 'large'
}>()

const { width, height } =
  size === 'large' ? { width: '24px', height: '24px' } : { width: '20px', height: '20px' }
</script>

<template>
  <div class="flex flex-row w-full justify-between items-center mb-[5px] pr-4">
    <div class="flex flex-row items-center">
      <component :is="icon" :width="width" :height="height" :alt="label" class="mr-[7px]" />
      <Typography size="text-14-20" color="helper">{{ label }}</Typography>
    </div>
    <Typography class="flex justify-self-end font-semibold" color="helper" size="text-16-24">{{
      count
    }}</Typography>
  </div>
</template>
